'use client'

interface HeaderSidebarToggleButtonProps {
  isOpen: boolean
  onToggle: () => void
  ariaLabel?: string
}

export default function HeaderSidebarToggleButton({
  isOpen,
  onToggle,
  ariaLabel = 'Toggle navigation',
}: HeaderSidebarToggleButtonProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="lg:hidden inline-flex items-center justify-center rounded-md bg-primary-100 p-2.5 sm:p-2.5 text-white hover:bg-primary-80 transition-colors"
      aria-label={ariaLabel}
      aria-expanded={isOpen}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-5 h-5 sm:w-4 sm:h-4 flex-shrink-0"
      >
        {isOpen ? (
          <>
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </>
        ) : (
          <>
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </>
        )}
      </svg>
    </button>
  )
}
